<template>
  <window
    :size="size"
    :title="windowTitle"
    @hide="onHide"
    @closed="onHide"
    overflow="auto"
    :class="`${openIframe} window-files`"
  >
    <template slot-scope="window">
      <table class="table w-100 mb-3" v-if="isTable && files.length > 0">
        <thead>
          <tr class="th-items">
            <th>Titel</th>
            <th>Pfad</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in files" v-bind:key="index">
            <td>{{ item.title }}</td>
            <td>{{ item.path }}</td>
            <td>
              <p>
                <button @click="showFile(item)" class="view-iframe">
                  <svg
                    width="1.8em"
                    height=" 1.8em"
                    viewBox="0 0 16 16"
                    class="bi bi-eye"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"
                    />
                  </svg>
                </button>
                <!-- <a :href="fileUrlDownload(item)" :download="item.title"> -->
                <a href="#" @click="downloadpdf(item)">
                  <svg
                    width="1.8em"
                    height=" 1.8em"
                    viewBox="0 0 16 16"
                    class="bi bi-cloud-arrow-down"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708l2 2z"
                    />
                  </svg>
                </a>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <template v-if="file && file.showable && !isTable">
        <template
          v-if="
            file.extension == 'jpg' ||
            file.extension == 'jpeg' ||
            file.extension == 'png'
          "
        >
          <img class="img-iframe" :src="fileUrlShow" alt="" />
        </template>
        <template v-else>
          <iframe :src="fileUrlShow" class="documnet-preview"></iframe>
          <!-- <embed src="path/filename.pdf#toolbar=1" width="500" height="375"> -->
          <!-- <vue-pdf-app
            :pdf="fileUrlShow"
            theme="light"
            @after-created="afterCreatedHandler"
          ></vue-pdf-app> -->
        </template>
      </template>

      <p v-if="files.length == 0">Keine Vorschau verfügbar</p>
    </template>
  </window>
</template>

<script>
import NeedsIcons from "../Mixins/NeedsIcons";
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";

export default {
  mixins: [NeedsIcons],
  provide: {
    windowId: "files",
  },
  components: {
    VuePdfApp,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "full-space",
    },
    files: {
      type: Array,
      default() {
        return [];
      },
    },
    initialIndex: {
      type: Number,
      default: 0,
    },
    urlPrefix: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      index: this.initialIndex,
      file: null,
      isTable: true,
      localdata: null,
      openIframe: "",
      db: null,
      ready: null,
      getLocalfiles: [],
    };
  },

  computed: {
    windowTitle() {
      const fileTitle = this.file ? this.file.label || this.file.title : null;

      return this.title + (fileTitle ? ` - ${fileTitle}` : "");
    },
    fileUrlShow() {
      return this.fileUrlDownload(this.file, true);
      return this.file.src
        ? this.file.src
        : `${this.urlPrefix}/files/show/${this.file.route}`;
      // }
    },
  },
  async created() {
    if (this.urlPrefix) {
      this.startIndexedDB();
      await this.ready;
      const getLocalfiles = await this.getList("files");
      this.getLocalfiles = getLocalfiles;
    }
  },
  methods: {
    afterCreatedHandler(pdfApp) {
      const func = (pdfApp) => {
        // may be this can help
        pdfApp.forceRendering();
      };

      // use underscore or lodash debounce to avoid intermediate resize and increase performance
      const debounced = lodash.debounce(func, 2000, {
        trailing: true,
        leading: false,
      });

      window.addEventListener("resize", debounced);

      // don't forget to unbind handler on component destroy
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("resize", debounced);
      });
    },
    urlById(id) {
      let res = this.getLocalfiles.find((x) => {
        if (x.id == id) {
          return true;
        }
      });
      return res;
    },
    downloadpdf(item) {
      // window.location =this.fileUrlDownload(item);
      window.open(this.fileUrlDownload(item), "_blank");
    },
    showFile(data) {
      this.isTable = false;
      this.file = data;
      this.openIframe = "open-iframe";
      document.body.classList.add("open-iframe");
    },
    fileUrlDownload(item, preview = false) {
      const res = this.urlById(item.id);
      if (res && res != undefined && res.value) {
        let url = window.URL.createObjectURL(res.value);
        return url;
      }
      return item.src
        ? item.src
        : `${this.urlPrefix}/files/${preview ? "show" : "download"}/${
            item.route
          }`;
    },

    onHide() {
      this.openIframe = "";
      document.body.classList.remove("open-iframe");
      if (this.isTable) {
        for (let file of this.files) {
          if (file.src && file.src.indexOf("blob:") === 0) {
            URL.revokeObjectURL(file.src);
          }
        }
      } else {
        this.isTable = true;
      }
    },
    startIndexedDB() {
      this.ready = new Promise((resolve, reject) => {
        const dbRequest = window.indexedDB.open("smartdoors", 2);

        dbRequest.onsuccess = (e) => {
          this.db = e.target.result;
          resolve(this.db);
        };

        dbRequest.onerror = (e) => {
          console.log("erro", e);
          reject(e);
        };
      });
    },

    async getList(key) {
      return new Promise((resolve, reject) => {
        const objectStore = this.getObjectStore(key);
        const list = [];

        objectStore.openCursor().onsuccess = (e) => {
          const cursor = e.target.result;

          if (cursor) {
            list.push(cursor.value);
            cursor.continue();
          } else {
            resolve(list);
          }
        };
      });
    },
    getObjectStore(store, mode = "readonly") {
      if (typeof store != "string") {
        return store;
      }

      const transaction = this.db.transaction([store], mode);

      return transaction.objectStore(store);
    },
  },
};
</script>
<style lang="scss">
.th-items {
  background-color: black;
  color: white;
  th {
    text-align: inherit;
    border: 1px solid white;
    &:hover {
      cursor: pointer;
    }
    span {
      float: right;
    }
  }
}
table th,
td {
  padding: 3px 10px;
}
table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
  border-top: 1px solid #929191;
  border-bottom: 1px solid #929191;
}
.window .documnet-preview {
  height: -webkit-fill-available;
  touch-action: auto;
  min-height: 100%;
}
.window__container--visible .window__content td:last-child p {
  margin-bottom: 0;
}
.window__container--visible .window__content svg {
  margin: 0 6px;
}
.window__container {
  min-width: 100%;
  height: 100%;
}
.window-files .window__content {
  height: calc(100% - 30px);
}
.img-iframe {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: left;
}
.open-iframe {
  touch-action: pan-y;
}
@media (any-pointer: coarse) {
  .view-iframe {
    display: none;
  }
}
</style>